import { render, staticRenderFns } from "./SinglePageConnection.vue?vue&type=template&id=6f19d3b3&"
import script from "./SinglePageConnection.vue?vue&type=script&lang=js&"
export * from "./SinglePageConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports